'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtImageDeviation', [
	'auth',
	'GlobalImageService',
	'$i18next',
	function (auth, GlobalImageService, $i18next) {
		return {
			restrict: 'E',
			scope: {
				showDialog: '=show',
				network: '@',
				imageType: '@',
				locations: '=',
				close: '&',
				isCoverImageSet: '<',
				isProfileImageSet: '<'
			},
			link: function (scope) {
				let removeImage = function (place, network, type) {
					place.imageStatus = 'updating';
					let locationCopy = angular.copy(place);

					GlobalImageService.setBrandImage(
						locationCopy,
						auth.user.selectedSite,
						network,
						type
					).then(
						function () {
							place.networkMedia = locationCopy.networkMedia;
							place.imageStatus = 'success';
						},
						function () {
							place.imageStatus = 'error';
						}
					);
				};

				scope.setImage = function (place) {
					removeImage(place, scope.network, scope.imageType + 'Image');
				};

				scope.onClose = function () {
					scope.close();
				};

				scope.updateAll = function () {
					scope.locations.forEach(function (place) {
						removeImage(place, scope.network, scope.imageType + 'Image');
					});
				};

				scope.renderTranslations = function (imageType) {
					let networkName = '';
					let imageTypeName = '';
					switch (scope.network) {
						case 'facebook':
							networkName = 'Facebook';
							imageTypeName = imageType;
							break;
						case 'google':
							networkName = 'Google';
							imageTypeName = imageType === 'profile' ? 'logo' : imageType;
							break;
						default:
							imageTypeName = imageType;
							break;
					}

					scope.deviationImage = $i18next.t('listings.media_upload.customized_image', {
						imageType: $i18next.t('general.' + imageTypeName),
						network: networkName
					});

					scope.useImage = $i18next.t('listings.media_upload.use_image', {
						imageType: $i18next.t('general.' + imageTypeName)
					});

					scope.imageForAllLocations = $i18next.t('listings.media_upload.image_for_all_locations', {
						imageType: $i18next.t('general.' + imageTypeName)
					});
				};
				scope.renderTranslations(scope.imageType);

				scope.$on('updateImageType', (info, value) => {
					scope.renderTranslations(value.imageType);
				});

				scope.getUseImage = () => {
					return scope.imageType === 'cover' ? scope.isCoverImageSet : scope.isProfileImageSet;
				};
			},
			templateUrl: 'components/tasks/pmtImageDeviation.html'
		};
	}
]);
